import { Component } from '@angular/core';
import { MetaService } from '@shared/services/meta/meta.service';
import { SettingsService } from '../../../core/settings/settings.service';

@Component({
  selector: 'app-error500',
  templateUrl: './error500.component.html',
  styleUrls: ['./error500.component.scss']
})
export class Error500Component {

  constructor(
    public settings: SettingsService,
    private metaService: MetaService
  ) {
    this.metaService.setTitleExternalPage('500 error');
  }

}
